<template>
  <div v-if="!!settings">
    <Teleport to="#header">
      <BMHeaderRich
        v-if="typeof settings.content.header_rich_default !== 'string' && settings.content.header_rich_default?.content"
        :blok="settings.content.header_rich_default.content"
        :inPageBlok="settings.content.header_rich_default.content.shop_header_in_page" />

      <!-- Shopping cart -->
      <BMShoppingCart
        v-if="
          typeof settings.content.shopping_cart !== 'string' &&
          settings.content.shopping_cart?.content &&
          typeof settings.content.header_rich_default !== 'string' &&
          settings.content.header_rich_default?.content
        "
        :blok="settings.content.shopping_cart.content"
        :headerBlok="settings.content.header_rich_default?.content" />
    </Teleport>
    <Teleport to="#footer">
      <BMFooter
        v-if="typeof settings.content.footer_default !== 'string' && settings.content.footer_default?.content"
        :blok="settings.content.footer_default.content" />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { useStoryblokClient } from '@seb-platform/shared/composables';
import type { ISbStoryData } from 'storyblok';
import { onMounted, ref } from 'vue';
import BMFooter from '~/components/storyblok/basic/BMFooter/BMFooter.vue';
import BMHeaderRich from '~/components/storyblok/basic/BMHeaderRich/BMHeaderRich.vue';
import BMShoppingCart from '~/components/storyblok/basic/BMShoppingCart/BMShoppingCart.vue';
import { Locale } from '~/types/locales';
import type { CoreSettingsStoryblok } from '~/types/storyblok-generated';
import initialSettingsData from './header-footer-export-settings-data.json';

interface LocalStorageSettingsData {
  cv: number;
  settings: ISbStoryData<CoreSettingsStoryblok>;
}

const settings = ref<ISbStoryData<CoreSettingsStoryblok>>(
  initialSettingsData as unknown as ISbStoryData<CoreSettingsStoryblok>
);

const locale = Locale.DE_DE; // The shop is only available in DE for now

onMounted(async () => {
  const { getCurrentCv, getSettings } = await useStoryblokClient();
  const currentCv = await getCurrentCv();

  const storedSettingsDataRaw = localStorage.getItem('wmf-settings-data');

  if (storedSettingsDataRaw) {
    const storedSettingsData = JSON.parse(storedSettingsDataRaw) as LocalStorageSettingsData;

    if (storedSettingsData.cv === currentCv) {
      settings.value = storedSettingsData.settings;
      return;
    }
  }

  settings.value = (await getSettings<CoreSettingsStoryblok>(locale)).value;
  localStorage.setItem('wmf-settings-data', JSON.stringify({ cv: currentCv, settings: settings.value }));
});
</script>

<style lang="scss" scoped>
@use '~/assets/scss/variables';

.has-black-bg {
  background-color: variables.$black;
}

.has-white-bg {
  background-color: variables.$white;
}
</style>
